<template>
	<div class="myInviteCode py-[20px]  box-border h-full " @click="copySuccessShow=false">
		<div class=" mb-[24px]" v-html="MICMI_content">
		</div>
		<div class="flex items-center justify-between " v-for="(item,index) in invitation_code_list" :key="index">
			<div class="flex items-center relative">
				<div
					class="w-[66px] h-[26px] mr-[16px] cursor-pointer leading-[26px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
					{{item.new_discount}}
				</div>
				<div class="text-[16px] mr-[8px]">
					{{item.code}}
				</div>
				<img @click.stop="copyClick(item,index)" src="@/static/image/icon59.png"
					class="w-[16px] h-[16px] cursor-pointer mr-[10px]" alt="" />
				<el-popover placement="bottom" width="280" trigger="hover">
					<div class="select-none" v-html="MICCI_content">
					</div>
					<img slot="reference" src="@/static/image/icon60.png" class="w-[15px] h-[15px] cursor-pointer "
						alt="" />
				</el-popover>
				<!-- <div
					class="copySign absolute w-[280px] p-[8px] top-[40px] right-[-76%] box-border bg-white rounded-[5px]">
				</div> -->
			</div>
			<!-- <div class="text-[#A6A6A6] text-[16px]">
				<label class="mr-[42px]">有效期：2071天</label>
				<label>剩余有效期：1653天</label>
			</div> -->
		</div>
		<div v-if="copySuccessShow" @click.stop="copySuccessShow=true"
			class="copySuccess box-border w-[310px] bg-white rounded-[5px] absolute top-[46%] left-[50%] "
			style="z-index: 10;">
			<div class="text-center text-[#FF0000] text-[14px] mb-[9px]">
				{{langInfo['Copy successfully']}}
			</div>
			<div class=" select-text " v-html="ICCS_content">
			</div>
		</div>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	export default {
		data() {
			return {
				copySuccessShow: false,
				invitation_code_list: [],
				MICCI_content: '',
				MICMI_content: "",
				ICCS_content: ''
			}
		},
		mounted() {

			EventBus.$on('userInfo', (res) => {
				console.log("res========");
				console.log(res);
				if (res) {
					this.get_user_invitation_code_list()
				}
			})
			this.get_user_invitation_code_list()

			this.MICCI_agreement() //我的邀请码复制须知
			this.MICMI_agreement() //我的邀请码营销使用说明
			this.ICCS_agreement() //复制成功提示

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			MICCI_agreement() {
				this.$api.agreement({
					mark: 'MICCI'
				}).then((res) => {
					console.log(res.data.content);
					this.MICCI_content = res.data.content
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			MICMI_agreement() {
				this.$api.agreement({
					mark: 'MICMI'
				}).then((res) => {
					console.log(res.data.content);
					this.MICMI_content = res.data.content
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			ICCS_agreement() {
				this.$api.agreement({
					mark: 'ICCS'
				}).then((res) => {
					console.log(res.data.content);
					this.ICCS_content = res.data.content
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			copyClick(item, index) {

				const textArea = document.createElement('textarea');
				textArea.value = item.code;
				textArea.style.position = 'fixed'; // 避免可见区域闪烁
				document.body.appendChild(textArea);
				textArea.select();
				// 尝试复制并处理可能的异常
				const success = document.execCommand('copy');
				document.body.removeChild(textArea);
				if (success) {
					// this.statusMessage = "已成功复制到剪贴板！"; //（兼容模式）
					// this.$message.success(this.statusMessage);
					this.copySuccessShow = true
				} else {
					this.$message.success("复制方法失败");
				}
			},
			get_user_invitation_code_list() {
				this.$api.user_invitation_code_list({}).then((res) => {
					console.log(res);
					this.invitation_code_list = res.data
				}).catch((error) => {})
			},

		}
	}
</script>

<style scoped>
	.copySign {
		box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
	}

	.copySuccess {
		box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
		padding: 18px 12px;
		transform: translateX(-50%);
	}
</style>